import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventario-resagado',
  templateUrl: './lista.component.html'
})

export class ResagadoComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}